/* ============================================================
   slp-cx-quiz-2.js — NuStrips Sleep Assessment quiz engine.
   Ported from cx-quiz.js. 3 products (sleep/essentials/energy).
   Flow: land → q1..q6 → email → loading → result. Scoped #slpq2.
   ============================================================ */
(function () {
  "use strict";

  var SCREENS = ["land", "q1", "q2", "q3", "q4", "q5", "q6", "email", "loading", "result"];
  var LOADING_DELAY_MS = 2600;
  var STEP_LABEL = { q1: 1, q2: 2, q3: 3, q4: 4, q5: 5, q6: 6 };

  var CADENCE = { sleep: "10PM NIGHTLY", essentials: "9AM DAILY", energy: "2PM DAILY" };

  var PRICE_TABLE = {
    sleep:      { otp: 39.99, sub: 28.99 },
    essentials: { otp: 39.99, sub: 28.99 },
    energy:     { otp: 39.99, sub: 28.99 }
  };
  var BUNDLE_2_PCT = 10, BUNDLE_3_PCT = 20, WELLNESS_THREE = 15, TOTAL_PRODUCTS = 3;
  var DISCOUNT = { bundle_2: "NUBUNDLE2", bundle_3: "NUBUNDLE3", wellness_three: "NUWELL15" };

  var CONFIG_DEFAULT = {
    shop_domain: "nustrips.myshopify.com",
    monthly_selling_plan: "4617470167",
    variants: { sleep: "44052420755671", essentials: "46996555563223", energy: "48418858827991" }
  };

  var round = function (n) { return Math.round(n * 100) / 100; };
  var fmt = function (n) { return "$" + n.toFixed(2); };

  /* ---- recommendation: sleep PRIMARY; essentials/energy escalate by signals ---- */
  function computeRecommendation(a) {
    var energyPri = a.q4 === "afternoon-crash" || a.q4 === "caffeine";
    var essPri    = a.q5 === "stress" || a.q5 === "all";
    return {
      tiers: {
        sleep: "PRIMARY",
        essentials: essPri ? "PRIMARY" : "RECOMMENDED",
        energy: energyPri ? "PRIMARY" : "RECOMMENDED"
      },
      qty: { sleep: 1, essentials: 1, energy: 1 }
    };
  }

  /* ---- sleep score from answers (lower = worse; we promise to lift it) ---- */
  function computeScore(a) {
    var s = 88;
    var struggle = { "cant-fall": -14, "wake-night": -16, "not-enough": -18, "groggy": -12, "travel": -10 };
    var dur = { weeks: -2, months: -6, years: -10, forever: -13 };
    var day = { "afternoon-crash": -6, "caffeine": -6, "brain-fog": -7, "fine-day": 0 };
    s += (struggle[a.q1] || -12) + (dur[a.q2] || -4) + (day[a.q4] || -3);
    return Math.max(41, Math.min(79, s));
  }

  /* ---- sleeper type: archetype + why-you-need-the-stack (keyed on Q1 struggle) ---- */
  var SLEEPER_TYPES = {
    "cant-fall":  { name: "The Overthinker",      why: "Your mind won't clock out, so you lie there while it races. You don't need more melatonin — you need melatonin that absorbs. Sublingual strips hit your bloodstream in minutes (pills lose 85–97% in your gut), so you're out before the spiral starts." },
    "wake-night": { name: "The 3 AM Riser",       why: "You fall asleep fine, then snap awake and can't drop back — usually a cortisol spike, not just low melatonin. Fast sublingual melatonin resets the night while daytime ashwagandha lowers the cortisol that's waking you up." },
    "not-enough": { name: "The Running-on-Empty", why: "You're short on sleep and your days pay the interest. Melatonin that actually absorbs makes the hours you do get go deeper — and a clean daytime lift keeps you off the caffeine rollercoaster until it's fixed." },
    "groggy":     { name: "The Groggy Riser",     why: "You sleep, but wake up wrecked — the melatonin hangover most pills leave behind. Micro-dosed sublingual strips give you the dose you need and nothing you don't, so you wake up clear instead of foggy." },
    "travel":     { name: "The Time-Zone Hopper", why: "Travel and shifting schedules wreck your rhythm faster than anything. Fast-absorbing sublingual melatonin lets you reset on demand wherever you land, while the daytime stack keeps your energy steady as your clock catches up." }
  };
  function computeSleeperType(a) {
    return SLEEPER_TYPES[a.q1] || { name: "The Restless Sleeper", why: "Your sleep isn't working the way it should — and most pills barely absorb. Fast sublingual melatonin plus a calming daytime stack is built to fix the root cause, not mask it." };
  }

  function applyRecommendation(root, rec) {
    Object.keys(rec.tiers).forEach(function (p) {
      var el = root.querySelector('[data-cx-tag="' + p + '"]');
      if (el) el.textContent = rec.tiers[p] + " · " + CADENCE[p];
    });
  }

  function init(root) {
    if (!root) return;
    var stage = root.querySelector("[data-cx-stage]");
    var screens = Array.prototype.slice.call(root.querySelectorAll("[data-cx-screen]"));
    var byId = {};
    screens.forEach(function (s) { byId[s.getAttribute("data-cx-screen")] = s; });
    var state = { id: "land", answers: {}, qty: { sleep: 1, essentials: 1, energy: 1 }, subscribe: true, stepAt: Date.now() };

    var track = function (n, p) { try { if (window.cxTrack) window.cxTrack(n, p); } catch (e) {} };
    track("cx_quiz_started", { quiz: "slp-cx-quiz-2" });
    track("cx_quiz_step_viewed", { step: "land" });

    window.addEventListener("beforeunload", function () {
      if (state.id !== "result") {
        track("cx_quiz_abandoned", { last_step: state.id, time_in_session_ms: Date.now() - state.stepAt });
      }
    });

    function go(targetId) {
      var next = byId[targetId];
      if (!next || next === byId[state.id]) return;
      screens.forEach(function (s) { s.classList.remove("is-active"); });
      next.classList.add("is-active");
      state.id = targetId;
      state.stepAt = Date.now();
      track("cx_quiz_step_viewed", { step: targetId });

      if (targetId === "email") { lockApprovedPct(); }
      if (targetId === "loading") { track("cx_quiz_loading_viewed", {}); setTimeout(function () { go("result"); }, LOADING_DELAY_MS); }
      if (targetId === "result") { enterResult(); }
      if (stage && stage.scrollIntoView) stage.scrollIntoView({ block: "start", behavior: "instant" });
      window.scrollTo(0, 0);
    }

    function enterResult() {
      var rec = computeRecommendation(state.answers);
      Object.keys(rec.qty).forEach(function (p) {
        state.qty[p] = rec.qty[p];
        var q = root.querySelector('[data-cx-qty="' + p + '"]'); if (q) q.textContent = rec.qty[p];
      });
      applyRecommendation(root, rec);
      var sc = root.querySelector("[data-cx-score]"); if (sc) sc.textContent = computeScore(state.answers);
      var st = computeSleeperType(state.answers);
      var tn = root.querySelector("[data-cx-type-name]"); if (tn) tn.textContent = st.name;
      var tw = root.querySelector("[data-cx-type-why]"); if (tw) tw.textContent = st.why;
      updateReceipt();
      lockApprovedPct();
      (function () {
        try {
          var cfg = (window.SLPQ2_CONFIG && window.SLPQ2_CONFIG.variants) ? window.SLPQ2_CONFIG : CONFIG_DEFAULT;
          var items = Object.keys(state.qty).filter(function (k) { return state.qty[k] > 0; }).map(function (p) { return { product: p, qty: state.qty[p] }; });
          warmCart(cfg, items, !!state.subscribe, computeCartDiscountCodes());
        } catch (e) {}
      })();
      track("cx_quiz_results_viewed", { recommended_stack: Object.keys(state.qty).filter(function (k) { return state.qty[k] > 0; }).join("+"), score: computeScore(state.answers) });
    }

    /* ---- taps ---- */
    root.addEventListener("click", function (e) {
      var nx = e.target.closest("[data-cx-next]");
      if (nx) {
        e.preventDefault();
        var dest = nx.getAttribute("data-cx-next");
        var scr = nx.closest("[data-cx-screen]");
        var sid = scr ? scr.getAttribute("data-cx-screen") : null;
        var val = nx.getAttribute("data-cx-value") || (nx.textContent || "").trim();
        if (sid && val && sid !== "land") {
          state.answers[sid] = val;
          track("cx_quiz_step_answered", { step: sid, answer: val, step_dwell_ms: Date.now() - state.stepAt });
        }
        go(dest); return;
      }
      var bk = e.target.closest("[data-cx-back]");
      if (bk) { e.preventDefault(); go(bk.getAttribute("data-cx-back")); return; }

      var st = e.target.closest("[data-cx-step]");
      if (st) {
        e.preventDefault();
        var p = st.getAttribute("data-cx-product"), dir = st.getAttribute("data-cx-step");
        var q = state.qty[p] || 0; q = dir === "+" ? Math.min(q + 1, 9) : Math.max(q - 1, 0);
        state.qty[p] = q;
        var qe = root.querySelector('[data-cx-qty="' + p + '"]'); if (qe) qe.textContent = q;
        updateReceipt(); return;
      }
      var sb = e.target.closest("[data-cx-sub-toggle]");
      if (sb) { e.preventDefault(); state.subscribe = !state.subscribe; sb.setAttribute("aria-pressed", state.subscribe ? "true" : "false"); updateReceipt(); return; }
      var ab = e.target.closest("[data-cx-add-to-cart]");
      if (ab) { e.preventDefault(); addToCart(); return; }
    });

    /* ---- email ---- */
    var ef = root.querySelector("[data-cx-email-form]");
    if (ef) ef.addEventListener("submit", function (e) {
      e.preventDefault();
      var inp = ef.querySelector('input[type="email"]'); var email = inp ? inp.value : "";
      state.answers.email = email;
      track("cx_quiz_email_captured", { email: email, full_answers: state.answers, recommended_stack: Object.keys(state.qty).filter(function (k) { return state.qty[k] > 0; }).join("+") });
      go("loading");
    });

    /* ---- receipt (3-product port of bundle math) ---- */
    function updateReceipt() {
      var wrap = root.querySelector("[data-cx-receipt-lines]"); if (!wrap) return;
      var keys = ["sleep", "essentials", "energy"];
      var labels = { sleep: "Sleep × 30ct", essentials: "Essentials × 30ct", energy: "Energy × 30ct" };
      var items = keys.filter(function (k) { return state.qty[k] > 0; });
      var totalQty = items.reduce(function (s, k) { return s + state.qty[k]; }, 0);
      var unique = items.length;
      while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
      if (totalQty === 0) { setText("[data-cx-subtotal]", "$0.00"); setText("[data-cx-total]", "$0.00"); return; }
      var sub = !!state.subscribe;
      var subtotalOtp = round(items.reduce(function (s, k) { return s + state.qty[k] * PRICE_TABLE[k].otp; }, 0));
      var afterSub = round(items.reduce(function (s, k) { return s + state.qty[k] * (sub ? PRICE_TABLE[k].sub : PRICE_TABLE[k].otp); }, 0));
      var subSavings = sub ? round(subtotalOtp - afterSub) : 0;
      var bundlePct = totalQty >= 3 ? BUNDLE_3_PCT : (totalQty === 2 ? BUNDLE_2_PCT : 0);
      var bundleAmt = round(items.reduce(function (s, k) {
        var lp = sub ? PRICE_TABLE[k].sub : PRICE_TABLE[k].otp;
        return s + (Math.floor(lp * (bundlePct / 100) * 100) / 100) * state.qty[k];
      }, 0));
      var afterBundle = round(afterSub - bundleAmt);
      var wellnessAmt = unique === TOTAL_PRODUCTS ? WELLNESS_THREE : 0;
      var finalTotal = round(afterBundle - wellnessAmt);
      var totalSavings = round(subtotalOtp - finalTotal);

      items.forEach(function (k) {
        var qty = state.qty[k];
        var row = document.createElement("div"); row.className = "rline";
        var a = document.createElement("span"); a.textContent = qty > 1 ? labels[k] + " (×" + qty + ")" : labels[k];
        var b = document.createElement("span"); b.textContent = fmt(round(qty * PRICE_TABLE[k].otp));
        row.appendChild(a); row.appendChild(b); wrap.appendChild(row);
      });
      setText("[data-cx-subtotal]", fmt(subtotalOtp));
      setText("[data-cx-bundle-label]", bundlePct > 0 ? "Bundle savings (" + bundlePct + "% off)" : "Bundle savings");
      setText("[data-cx-bundle-discount]", bundleAmt > 0 ? "−" + fmt(bundleAmt) : "$0.00");
      setText("[data-cx-sub-discount]", subSavings > 0 ? "−" + fmt(subSavings) : "$0.00");
      setText("[data-cx-wellness-label]", "🎁 Wellness Bonus (all 3 added)");
      setText("[data-cx-wellness-discount]", wellnessAmt > 0 ? "−" + fmt(wellnessAmt) : "$0.00");
      setText("[data-cx-total]", fmt(finalTotal) + (sub ? "/mo" : ""));
      setText("[data-cx-strike]", totalSavings > 0 ? fmt(subtotalOtp) : "");
      setText("[data-cx-save]", totalSavings > 0 ? "🎉 You save " + fmt(totalSavings) + (sub ? " vs. one-time" : " today") : "");
      setText("[data-cx-cta-total]", "Complete Checkout →");
      toggle("[data-cx-bundle-row]", bundleAmt > 0);
      toggle("[data-cx-wellness-row]", wellnessAmt > 0);
      toggle("[data-cx-sub-row]", subSavings > 0);
      keys.forEach(function (p) { var t = root.querySelector('[data-cx-tile][data-product="' + p + '"]'); if (t) t.setAttribute("data-qty", String(state.qty[p] || 0)); });
    }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function toggle(sel, on) { var el = root.querySelector(sel); if (el) el.style.display = on ? "" : "none"; }

    function computeCartDiscountCodes() {
      var codes = [];
      var items = Object.keys(state.qty).filter(function (k) { return state.qty[k] > 0; });
      var totalQty = items.reduce(function (s, k) { return s + state.qty[k]; }, 0);
      if (totalQty >= 3) codes.push(DISCOUNT.bundle_3); else if (totalQty === 2) codes.push(DISCOUNT.bundle_2);
      if (items.length === TOTAL_PRODUCTS) codes.push(DISCOUNT.wellness_three);
      return codes;
    }

    function buildCartUrl(cfg, items, sub, codes) {
      var lines = items.map(function (it) { var v = cfg.variants[it.product]; return v ? v + ":" + it.qty : null; }).filter(Boolean);
      if (!lines.length) return null;
      var p = [];
      if (sub && cfg.monthly_selling_plan) p.push("selling_plan=" + encodeURIComponent(cfg.monthly_selling_plan));
      if (codes.length) p.push("discount=" + encodeURIComponent(codes.join(",")));
      return "https://" + cfg.shop_domain + "/cart/" + lines.join(",") + (p.length ? "?" + p.join("&") : "");
    }
    function isOnShopify() { var h = location.hostname || ""; return h.indexOf(".myshopify.com") >= 0 || h === "nustrips.com" || h.indexOf(".nustrips.com") >= 0; }

    function suppressSlideCart() {
      try { if (typeof window.upcartCloseCart === "function") window.upcartCloseCart();
        document.body.classList.remove("upcartPopupShow", "upcart-show", "cart-drawer-open", "drawer-open", "mini-cart-open", "js-drawer-open"); } catch (e) {}
    }
    async function warmCart(cfg, items, sub, codes) {
      if (!isOnShopify()) return;
      var planId = cfg.monthly_selling_plan ? parseInt(cfg.monthly_selling_plan, 10) : null;
      var adds = items.map(function (it) { var v = parseInt(cfg.variants[it.product], 10); if (!v) return null; var l = { id: v, quantity: it.qty }; if (sub && planId) l.selling_plan = planId; return l; }).filter(Boolean);
      if (!adds.length) return;
      try { await fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } }); } catch (e) { return; }
      suppressSlideCart();
      try { await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: adds }) }); } catch (e) { return; }
      suppressSlideCart();
      for (var i = 0; i < codes.length; i++) {
        if (i > 0) await new Promise(function (r) { setTimeout(r, 700); });
        try { await fetch("/discount/" + encodeURIComponent(codes[i]) + "?redirect=/cart.js", { redirect: "follow" }); } catch (e) {}
        suppressSlideCart();
      }
    }
    async function submitCartFormPost(cfg, items, sub, codes) {
      var planId = cfg.monthly_selling_plan ? parseInt(cfg.monthly_selling_plan, 10) : null;
      var adds = items.map(function (it) { var v = parseInt(cfg.variants[it.product], 10); if (!v) return null; var l = { id: v, quantity: it.qty }; if (sub && planId) l.selling_plan = planId; return l; }).filter(Boolean);
      if (!adds.length) return;
      try { await fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } }); } catch (e) {}
      var form = document.createElement("form"); form.method = "post"; form.action = "/cart/add"; form.style.display = "none";
      adds.forEach(function (item, i) { Object.keys(item).forEach(function (k) { var inp = document.createElement("input"); inp.type = "hidden"; inp.name = "items[" + i + "][" + k + "]"; inp.value = String(item[k]); form.appendChild(inp); }); });
      var tp = new URLSearchParams(); var pass = /^(utm_|gclid$|fbclid$|ttclid$|msclkid$|irclickid$|ref$)/i;
      new URLSearchParams(window.location.search).forEach(function (v, k) { if (pass.test(k)) tp.set(k, v); });
      if (codes.length) tp.set("discount", codes.join(","));
      var qs = tp.toString();
      var rt = document.createElement("input"); rt.type = "hidden"; rt.name = "return_to"; rt.value = "/checkout" + (qs ? "?" + qs : ""); form.appendChild(rt);
      document.body.appendChild(form); form.submit();
    }
    function addToCart() {
      var items = []; Object.keys(state.qty).forEach(function (p) { if (state.qty[p] > 0) items.push({ product: p, qty: state.qty[p] }); });
      var cfg = (window.SLPQ2_CONFIG && window.SLPQ2_CONFIG.variants) ? window.SLPQ2_CONFIG : CONFIG_DEFAULT;
      var codes = computeCartDiscountCodes();
      var onSh = isOnShopify();
      track("cx_quiz_cart_added", { cart_payload: items, codes: codes, subscribe: !!state.subscribe, submit_mode: onSh ? "form_post" : "permalink" });
      if (onSh) setTimeout(function () { submitCartFormPost(cfg, items, !!state.subscribe, codes); }, 60);
      else { var u = buildCartUrl(cfg, items, !!state.subscribe, codes); if (u) setTimeout(function () { window.location.assign(u); }, 60); }
    }

    function lockApprovedPct() {
      var items = Object.keys(state.qty).filter(function (k) { return state.qty[k] > 0; });
      var totalQty = items.reduce(function (s, k) { return s + state.qty[k]; }, 0); if (!totalQty) return;
      var subtotalOtp = round(items.reduce(function (s, k) { return s + state.qty[k] * PRICE_TABLE[k].otp; }, 0));
      var afterSub = round(items.reduce(function (s, k) { return s + state.qty[k] * PRICE_TABLE[k].sub; }, 0));
      var bundlePct = totalQty >= 3 ? BUNDLE_3_PCT : (totalQty === 2 ? BUNDLE_2_PCT : 0);
      var bundleAmt = round(afterSub * bundlePct / 100);
      var wellness = items.length === TOTAL_PRODUCTS ? WELLNESS_THREE : 0;
      var finalT = round(afterSub - bundleAmt - wellness);
      var pct = Math.round(((subtotalOtp - finalT) / subtotalOtp) * 100);
      root.querySelectorAll("[data-cx-approved-pct]").forEach(function (el) { el.textContent = String(pct); });
    }

    byId.land.classList.add("is-active");
    updateReceipt();
    lockApprovedPct();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-cx-quiz-root]").forEach(init);
  });
  window.SLPQ2 = { init };
})();
